<template>
  <div class="profile">
    <div class="box p-5">
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-1"
          label="Địa chỉ Email:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="user.email"
            type="email"
            readOnly
            required
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Họ và tên:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="user.name"
            type="text"
            readOnly
            required
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Địa chỉ:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="user.address"
            type="text"
            readOnly
            required
            placeholder="Địa chỉ"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Số điện thoại:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="user.phone"
            type="text"
            readOnly
            required
            placeholder="Số điện thoại"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </div>

    <div class="box p-5 mt-2" v-if="user.affiliate_user && user.affiliate_user.name">
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-1"
          label="Được tạo bởi tài khoản:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="user.affiliate_user.name"
            type="text"
            readOnly
            required
            placeholder="Affiliate user name"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapGetters, mapState } from 'vuex'
import { mapState } from 'vuex'
// import { STORE_KEY } from '../_store/constants'

export default {
  name: 'UserProfile',
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  beforeMount() {
    // this.authInfo();
  },
  methods: {
    // ...mapActions('auth', ['authInfo']),
    onSubmit() {
      //
    }
  }
};
</script>